import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { closeSmall } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import ComplementaryAreaToggle from '../complementary-area-toggle';

const ComplementaryAreaHeader = _ref => {
  let {
    smallScreenTitle,
    children,
    className,
    toggleButtonProps
  } = _ref;
  const toggleButton = createElement(ComplementaryAreaToggle, _extends({
    icon: closeSmall
  }, toggleButtonProps));
  return createElement(Fragment, null, createElement("div", {
    className: "components-panel__header interface-complementary-area-header__small"
  }, smallScreenTitle && createElement("span", {
    className: "interface-complementary-area-header__small-title"
  }, smallScreenTitle), toggleButton), createElement("div", {
    className: classnames('components-panel__header', 'interface-complementary-area-header', className),
    tabIndex: -1
  }, children, toggleButton));
};

export default ComplementaryAreaHeader;
//# sourceMappingURL=index.js.map